import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const AllIntroComponent = React.lazy(() => import("../Components/RootComponents/AllIntroComponent"));
const AllIntroPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <AllIntroComponent />
      </Suspense>
    </Fragment>
  );
};

export default AllIntroPage;
